/**
 * @module line/utils
 */

/**
 * Normalizes options
 *
 * @param {Array<String>} options Options to normalize.
 * @param {String} defaultValue Default value.
 * @returns {Array<{title:string, value: string}>}
 */
export function normalizeOptions( options, defaultValue ) {
	return options.map( option => {
		return {
			title: option === defaultValue ? 'Padrão' : option.replace( /[^0-9.,]+/g, '' ).replace( '.', ',' ),
			value: option
		}
	} );
}
